import { Bell, Gem, Menu, Sparkles } from 'lucide-react';
import { Link } from 'react-router-dom';

import { mockUser } from '../../mocks';

export function AppBar() {
  return (
    <header
      className="sticky top-0 z-40 h-14 border-b border-[var(--color-border)] bg-white/65 backdrop-blur-xl backdrop-saturate-150"
      style={{ paddingTop: 'env(safe-area-inset-top)' }}
    >
      <div className="mx-auto flex h-full max-w-3xl items-center justify-between px-4">
        <Link to="/app/home" className="flex items-center gap-1.5">
          <Sparkles className="h-5 w-5 text-[var(--color-lavender-500)]" />
          <span className="font-serif text-lg font-semibold">Lashpic</span>
        </Link>

        <div className="flex items-center gap-1">
          <Link
            to="/app/me/credits"
            className="flex items-center gap-1 rounded-full bg-[var(--color-lavender-50)] px-2.5 py-1.5 text-xs font-semibold text-[var(--color-lavender-700)]"
          >
            <Gem className="h-3.5 w-3.5" />
            {mockUser.credits}
          </Link>
          <button
            type="button"
            className="grid h-9 w-9 place-items-center rounded-full hover:bg-[var(--color-lavender-50)]"
            aria-label="알림"
          >
            <Bell className="h-4.5 w-4.5" />
          </button>
          <button
            type="button"
            className="grid h-9 w-9 place-items-center rounded-full hover:bg-[var(--color-lavender-50)]"
            aria-label="메뉴"
          >
            <Menu className="h-4.5 w-4.5" />
          </button>
        </div>
      </div>
    </header>
  );
}
